import { render, staticRenderFns } from "./FormAddMedico.vue?vue&type=template&id=0b415a7e&scoped=true&"
import script from "./FormAddMedico.vue?vue&type=script&lang=js&"
export * from "./FormAddMedico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b415a7e",
  null
  
)

export default component.exports